import { render, staticRenderFns } from "./SignUpText.vue?vue&type=template&id=f2eb6a56&scoped=true&"
import script from "./SignUpText.vue?vue&type=script&lang=ts&"
export * from "./SignUpText.vue?vue&type=script&lang=ts&"
import style0 from "./SignUpText.vue?vue&type=style&index=0&id=f2eb6a56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2eb6a56",
  null
  
)

export default component.exports